// extracted by mini-css-extract-plugin
export default {"homeTitle":"c-a_fQ","homeTitle_styleDefault":"c-a_fR","homeTitle_styleRed":"c-a_fS"};